import React from 'react';
import styled from 'styled-components';
import { MailOutlined } from '@ant-design/icons';

const FooterContainer = styled.footer`
  background-color: #fff;
  color: #666;
  padding: 40px 24px;
  text-align: center;
  border-top: 1px solid rgba(25, 118, 210, 0.1);
  box-shadow: 0 -2px 8px rgba(25, 118, 210, 0.05);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 24px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const FooterLink = styled.a`
  color: #666;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  
  &:hover {
    color: #1976d2;
  }
`;

const Copyright = styled.p`
  font-size: 14px;
  margin: 0;
  color: #666;
`;

const ICP = styled.a`
  color: #666;
  text-decoration: none;
  font-size: 14px;
  margin-top: 8px;
  display: block;
  transition: all 0.3s ease;
  
  &:hover {
    color: #1976d2;
  }
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLinks>
          <FooterLink href="mailto:dev@kalimbaflows.com">
            <MailOutlined style={{ marginRight: '8px' }} />
            dev@kalimbaflows.com
          </FooterLink>
        </FooterLinks>
        <Copyright>© {new Date().getFullYear()} Kalimba Flows. All rights reserved.</Copyright>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer; 